import React, {useState} from 'react'
import {createPortal} from 'react-dom'
import {Button, Modal} from 'react-bootstrap'
import {fetchStagingArticle} from '../../services/firebase'

const modalsRoot = document.getElementById('root-modals') || document.body

const ImportArticleModal = ({onClose, onArticleLoaded}) => {
  const [path, setPath] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleLookup = async (event) => {
    event.preventDefault()
    if(loading || !path.trim()) return

    setLoading(true)
    setError(null)
    try {
      const article = await fetchStagingArticle(path.trim())
      onArticleLoaded({...article, id: ''})
    } catch(err) {
      setError(err.message || 'Unable to load the article from staging. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return createPortal(
    <Modal show onHide={loading ? () => {} : onClose} centered aria-labelledby='import-article-title'>
      <Modal.Header>
        <Modal.Title id='import-article-title'>Import article from staging</Modal.Title>
      </Modal.Header>
      <form onSubmit={handleLookup}>
        <Modal.Body>
          <label htmlFor='staging-article-path' className='form-label required'>Article path</label>
          <input
            id='staging-article-path'
            type='text'
            className='form-control form-control-solid'
            value={path}
            onChange={event => {
              setPath(event.target.value)
              setError(null)
            }}
            disabled={loading}
            autoFocus
            required
            aria-describedby='staging-article-help'
          />
          <p id='staging-article-help' className='text-muted mt-3'>
            Enter the article path stored in staging (for example /digital-partners). You can review and edit the article before creating it.
          </p>
          {error && <div className='alert alert-danger mb-0' role='alert'>{error}</div>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='light' onClick={onClose} disabled={loading}>Cancel</Button>
          <Button type='submit' disabled={loading || !path.trim()}>
            {loading ? 'Looking up article...' : 'Load article'}
            {loading && <span className='spinner-border spinner-border-sm ms-2' aria-hidden='true' />}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>,
    modalsRoot
  )
}

export default ImportArticleModal
